import { render, staticRenderFns } from "./my-work.vue?vue&type=template&id=fac037d6"
import script from "./my-work.vue?vue&type=script&lang=js"
export * from "./my-work.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports